import { AxiosResponse } from 'axios'
import { url } from 'inspector'
import IExperienceApiResponse from 'src/system/content/api/IExperienceApiResponse'
import IExperienceService from 'src/system/content/services/IExperienceService'
import ILocalContentService from 'src/system/content/services/ILocalContentService'
import IRemoteContentService from 'src/system/content/services/IRemoteContentService'

export class ExperienceService implements IExperienceService {
  constructor(
    private readonly localContentService: ILocalContentService,
    private readonly remoteContentService: IRemoteContentService
  ) {
    //
  }

  async fetchAllExperiences(): Promise<void> {
    const response: AxiosResponse<IExperienceApiResponse[]> = await this.remoteContentService.request(
      'GET',
      '/api/experience?include=iframes'
    )

    const resources = []

    const responseExperiences = response.data.map((experience) => {
      resources.push(
        ...(experience.iframes || []).map((iframe) => ({
          resourceId: iframe.id.toString(),
          type: 'iframe',
          name: iframe.name,
          createdAt: iframe.created_at,
          updatedAt: iframe.updated_at,
          url: iframe.url,
          description: iframe.description,
          thumbnail: iframe.thumbnail,
        }))
      )

      return {
        id: experience.id.toString(),
        name: experience.name,
        createdAt: experience.created_at,
        updatedAt: experience.updated_at,
        resources: experience.iframes?.map((iframe) => 'iframe-' + iframe.id.toString()) || [],
      }
    })

    const db = this.localContentService.getDatabase()

    const storedIds = (await db.experiences.find().exec()).map((experience) => experience.id)
    const responseIds = responseExperiences.map((experience) => experience.id)

    const idsToDelete = storedIds.filter((id) => !responseIds.includes(id))

    await Promise.all([
      db.experiences.bulkRemove(idsToDelete),
      db.experiences.bulkUpsert(responseExperiences),
      db.resources.bulkUpsert(resources),
    ])
  }
}
